// Cookie-less auth: the opaque session token lives in localStorage and is sent as
// `Authorization: Bearer <token>` (and as ?token= on the WS). OAuth redirects hand the token
// back in the URL fragment (#token=...), which we capture on load.
const KEY = "maitv.token";

export function getToken(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setToken(t: string): void {
  try {
    localStorage.setItem(KEY, t);
  } catch {
    /* storage unavailable */
  }
}

export function clearToken(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

/** Capture a token handed back via the OAuth redirect fragment (#token=...), store it, strip it. */
export function consumeOAuthHash(): void {
  const hash = location.hash;
  if (!hash || hash.indexOf("token=") < 0) return;
  const m = hash.match(/[#&]token=([^&]+)/);
  if (m && m[1]) {
    setToken(decodeURIComponent(m[1]));
    const cleaned = hash.replace(/[#&]token=[^&]+/, "");
    const rest = cleaned === "#" || cleaned === "" ? "" : cleaned;
    history.replaceState(null, "", location.pathname + location.search + rest);
  }
}
